import React, { Component } from 'react';
import OptionsPanel from "./components/optionsPanel";
import './css/App.css';
import Game from "./logic/game";
import GameBoard from "./components/gameBoard";
import { DisplayOptions, GameOptions } from "./types";
import { findNewBoard } from "./logic/search";
import { Theme, ThemeContext } from "./themeContext";
import Constants from "./constants";

interface AppProps {
}

interface AppState {
    game?: Game,
    displayOptions?: DisplayOptions,
    theme: Theme,
}

class App extends Component<AppProps, AppState> {
    constructor(props: AppProps) {
        super(props);
        const savedTheme = (Constants.themePV.getValue() as Theme) || 'light';
        this.state = { theme: savedTheme };
        this.applyTheme(savedTheme);
    }

    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    handleKeyDown = (event: KeyboardEvent) => {
        // Only trigger on plain "z" — don't intercept Ctrl+Z (browser undo) or when typing in inputs
        if (
            event.key.toLowerCase() === 'z' &&
            !event.ctrlKey &&
            !event.metaKey &&
            !event.altKey &&
            !(event.target instanceof HTMLInputElement) &&
            !(event.target instanceof HTMLTextAreaElement) &&
            !(event.target instanceof HTMLSelectElement)
        ) {
            event.preventDefault();
            this.undo();
        }
    };

    applyTheme = (theme: Theme) => {
        document.documentElement.setAttribute('data-theme', theme);
    };

    toggleTheme = () => {
        this.setState(prevState => {
            const newTheme: Theme = prevState.theme === 'light' ? 'dark' : 'light';
            Constants.themePV.setValue(newTheme);
            this.applyTheme(newTheme);
            return { theme: newTheme };
        });
    };

    newGame = (options: GameOptions) => {
        console.log('Starting new game.');
        // console.log(`options.displayOptions.includeSelfInSeenBluesCount ${options.displayOptions.includeSelfInSeenBluesCount}`)
        this.setState({
            game: new Game(findNewBoard(options)),
            displayOptions: options.displayOptions,
        });
    }

    undo = () => {
        if (this.state.game) {
            console.log('Trying to undo previous move.');
            this.state.game.undo();
            this.forceUpdate();
        }
    }

    render() {
        const themeContextValue = {
            theme: this.state.theme,
            toggleTheme: this.toggleTheme,
        };

        return (
            <ThemeContext.Provider value={themeContextValue}>
                <div className="app">
                    <OptionsPanel
                        startFn={this.newGame}
                        undoFn={this.undo}
                        gameOn={!!this.state.game}
                    />
                    {this.state.game && this.state.displayOptions ?
                        <GameBoard
                            game={this.state.game}
                            displayOptions={this.state.displayOptions}
                        /> : <></>}
                </div>
            </ThemeContext.Provider>
        );
    }
}

export default App;
